<div fxLayout="column" fxLayoutGap="20px" >
  <div fxLayout="row">
    <mat-form-field appearance="outline">
      <input matInput maxlength="9" #userGmin placeholder="GMIN" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row">
    <button mat-raised-button color="primary" (click)="login(userGmin.value)">Login</button>
  </div>
</div>
